import { IRightsFilterModel } from "../ts/rlAdmin.models";
import { userDivAppUrlHash } from "../ts/rlAdmin.consts";
import * as moment from "moment";
import { SessionCacheService } from "./session-cache-service";

export class RightsFilterService {

    static $inject = ["sessionCacheService"];

    private cacheKey = userDivAppUrlHash + "_rights_filter_model";

    public lastDefaultFilterModel: IRightsFilterModel;

    constructor(private sessionCacheService: SessionCacheService) {

    }

    GetCachedFilter(defaultFilterModel: IRightsFilterModel) {
        this.lastDefaultFilterModel = defaultFilterModel;

        var cached = this.sessionCacheService.getItem<IRightsFilterModel>(this.cacheKey) || defaultFilterModel;
        if (cached == null) {
            return defaultFilterModel;
        } else {
            // merge any missing values from the default filter model to the cached filter model
            for (let key of Object.keys(defaultFilterModel)) {
                if (cached[key] == null) {
                    cached[key] = defaultFilterModel[key];
                } else if (_.isEmpty(cached[key]) && !_.isEmpty(defaultFilterModel[key])) {
                    cached[key] = defaultFilterModel[key];
                }
            }
            return cached;
        }
    }

    SetCachedFilterModel(model: IRightsFilterModel) {
        this.sessionCacheService.setItem(this.cacheKey, model, moment.duration(1, "day"));
    }
}